// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__9ZvGL","loader":"LoadingSpinner_loader__XTHyJ","rotation":"LoadingSpinner_rotation__u-tJ4","text":"LoadingSpinner_text__Kb6ax"};